export default __webpack_public_path__ + "static/media/IMG_2024.8bcce64b.JPG";